module.exports = __webpack_public_path__ + "img/alipay@2x.285d6a7b.png";